export const pathname = "/posties/404";

export const page = {
  route() {
    return {
      pathname,
    };
  },
};
